//
// https://github.com/tlhunter/node-autotile
//
import { BITMASK, E, N, NE, NW, S, SE, SW, W } from "./autotile_bitmask"
import { COMPUTABLE_WALL_AUTOTILE_INDICES } from "./autotile_library"

export { autotileIndexBitmask } from "./autotile_bitmask"

function autotileLookup(map, x_boundary, y_boundary, x, y) {
    let sum = 0
    let n = false
    let e = false
    let s = false
    let w = false

    if (!map[y][x]) return 0

    if (y > 0 && map[y - 1][x]) {
        n = true
        sum += N
    }
    if (x > 0 && map[y][x - 1]) {
        w = true
        sum += W
    }
    if (x < x_boundary && map[y][x + 1]) {
        e = true
        sum += E
    }
    if (y < y_boundary && map[y + 1][x]) {
        s = true
        sum += S
    }

    if (n && w && y > 0 && x > 0 && map[y - 1][x - 1]) sum += NW
    if (n && e && y > 0 && x < x_boundary && map[y - 1][x + 1]) sum += NE
    if (s && w && y < y_boundary && x > 0 && map[y + 1][x - 1]) sum += SW
    if (s && e && x < x_boundary && y < y_boundary && map[y + 1][x + 1]) sum += SE

    return BITMASK[sum]
}

// Autotile indices (the BITMASK values) a wall can be drawn at: the ones EVERY wall material in
// content/game/maps/autotiles.json has a rule for (kind "wall"; see wallDrawableIndices). A wall cell whose
// computed index falls outside this set has NO computable tile -- e.g. a 2x2 block, whose four cells
// compute to indices 34/26/7/4 -- so that placement is invalid. Derived, so a rule added to or
// removed from the data changes what may be placed with it, also by a live publication (the set is
// kept, and rebound, by autotile_library.ts).
export { COMPUTABLE_WALL_AUTOTILE_INDICES }

// Given a value from an autotile index grid, returns whether that cell is renderable as a wall.
// autotileLookup returns 0 for an empty cell (no wall -> fine), 1..47 for a wall (renderable only
// if every wall material has a rule for it), or undefined when the neighbor-sum has no BITMASK entry
// (only happens for wall cells -> uncomputable).
export const wallAutoTileCellComputable = (idx: number | undefined): boolean => {
    if (idx === 0) return true // no wall here
    if (idx === undefined) return false // wall with an unmapped neighbor configuration
    return COMPUTABLE_WALL_AUTOTILE_INDICES.has(idx)
}

export const autotile = map => {
    const tiles = []
    const height = map.length
    const width = map[0].length
    const x_boundary = width - 1
    const y_boundary = height - 1

    for (let y = 0; y < height; y++) {
        tiles[y] = []
        for (let x = 0; x < width; x++) {
            tiles[y][x] = autotileLookup(map, x_boundary, y_boundary, x, y)
        }
    }

    return tiles
}
